import * as React from "react"
import { appStrings } from "../../common/strings/app_strings"

const {
    onboarding: { skip },
} = appStrings

class OnboardingSection extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {
            sectionTitle,
            children,
            buttonValue,
            onClickAction,
            hasSkipButton,
            isXWide,
            extraBottomPadding,
        } = this.props

        return (
            <div
                className={`container onboarding ${isXWide &&
                    "x-wide-container"} ${extraBottomPadding &&
                    "extra-bottom-padding"}`}
            >
                <div className="row">
                    <div id={!isXWide && "signup-form"}>
                        <div className="row">
                            {sectionTitle && (
                                <div className="col-md-12 mb-2">
                                    <h4 className="sign-up-welcome-text">
                                        {sectionTitle}
                                    </h4>
                                </div>
                            )}
                            <div>{children}</div>
                            <div className="col-md-12">
                                {buttonValue && (
                                    <div className="form-actions">
                                        <button
                                            id="submit"
                                            className="btn btn-primary btn-block btn-lg"
                                            tabIndex="5"
                                            onClick={onClickAction}
                                        >
                                            {buttonValue}
                                        </button>
                                    </div>
                                )}
                                {hasSkipButton && (
                                    <div className="row">
                                        <p
                                            id="skip"
                                            className="text-center note-text"
                                            onClick={onClickAction}
                                        >
                                            {skip}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OnboardingSection



// WEBPACK FOOTER //
// ./src/components/onboarding/onboarding_section.jsx